function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2606",
  "data-name": "Group 2606",
  transform: "translate(-74.879 -307.321)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3682",
  "data-name": "Path 3682",
  d: "M34.041-85.036c0-10.773-19.506-35.318-19.506-35.318S-4.972-95.809-4.972-85.036A19.506,19.506,0,0,0,14.534-65.529,19.506,19.506,0,0,0,34.041-85.036Z",
  transform: "translate(92.438 429.175)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_563",
  "data-name": "Line 563",
  x1: 56.78,
  y2: 56.78,
  transform: "translate(77.001 310.82)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

var SvgOilfreeIcon = function SvgOilfreeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.023,
    height: 62.401,
    viewBox: "0 0 61.023 62.401",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOilfreeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/oilfree-icon.8b4c2c2d.svg";
export { ForwardRef as ReactComponent };